import styled from 'styled-components'

import Loader from 'components/Loader'

const LoaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${(props) => (props.fullheight ? '100vh' : 'auto')};

  ${({ overlay }) =>
    overlay &&
    `
    position: fixed;
    background-color: rgba(0,0,0,0.4);
    top: 0;
    left: 0;
    height: 100vh;
    z-index: 999999;
  `}
`

const LoaderDiv = ({ fullheight, overlay, size = 'lg' }) => (
  <LoaderContainer fullheight={fullheight} overlay={overlay}>
    <Loader size={size} />
  </LoaderContainer>
)

export default LoaderDiv
